import { render, staticRenderFns } from "./Form4StyleOfProceeding.vue?vue&type=template&id=6f2b2fd3&scoped=true"
import script from "./Form4StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form4StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form4StyleOfProceeding.vue?vue&type=style&index=0&id=6f2b2fd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b2fd3",
  null
  
)

export default component.exports